export const stateSelectOptions = [
  { value: '', text: 'Select your state' },
  { value: 'ACT', text: 'ACT' },
  { value: 'NSW', text: 'NSW' },
  { value: 'NT', text: 'NT' },
  { value: 'QLD', text: 'QLD' },
  { value: 'SA', text: 'SA' },
  { value: 'TAS', text: 'TAS' },
  { value: 'VIC', text: 'VIC' },
  { value: 'WA', text: 'WA' },
  { value: 'Other', text: 'Other' },
];

// Values need to match picklist API names in Salesforce, text can be different
export const roleSelectOptions = [
  { value: '', text: 'Select your role' },
  { value: 'Head of Science', text: 'Head of Science' },
  { value: 'Teacher', text: 'Teacher' },
  { value: 'Principal', text: 'Principal' },
  { value: 'Deputy Principal', text: 'Assistant / Deputy Principal' },
  {
    value: 'Director of Innovation',
    text: 'Director of Innovation / Head of eLearning',
  },
  {
    value: 'Head of Curriculum',
    text: 'Director of Teaching and Learning / Head of Curriculum / Pedagogy Leader',
  },
  {
    value: 'IT Lead',
    text: 'Director of ICT / IT Manager',
  },
  { value: 'Bursar / Business Manager', text: 'Bursar / Business Manager' },
  { value: 'Lab Tech', text: 'Lab Technician' },
  { value: 'Parent', text: 'Parent' },
  { value: 'Student', text: 'Student' },
  { value: 'Other', text: 'Other' },
];

// For forms that only school staff can fill in, so Parent and Student aren't
// valid positions.
export const staffOnlyRoleSelectOptions = roleSelectOptions.filter(
  ({ value }) => value !== 'Parent' && value !== 'Student'
);
